const LineSeparator = (): JSX.Element => {

    return (
        <hr
        style={{
          border: '0',
          borderTop: '1px solid #d3d3d3',
          margin: 0,
          width: '100%',
          height: '20px',
        }}
      />    );
  };

export default LineSeparator;